export function fileToDataURI(file: File | Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();

      reader.onload = function (event) {
        if (event.target && typeof event.target.result === 'string') {
          const dataURI = event.target.result;

          resolve(dataURI);
        } else {
          reject(new Error('Failed to convert File to Data URI.'));
        }
      };

      reader.readAsDataURL(file);
    } catch (error) {
      reject(error);
    }
  });
}
